import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projets`}</h2>
    <ProjectCard title="Platformer 2D Unity - WIP" link="https://github.com/TotallyNotAB0t/Unity_Platformer" bg="linear-gradient(to right, rgb(252, 132, 3) 0%, rgb(152, 32, 0) 100%)" mdxType="ProjectCard">
Création d'un jeu en C# sur Unity. Utilisation d'assets publics et création du code de A à Z.
    </ProjectCard>
    <ProjectCard title="Morpion" link="https://github.com/TotallyNotAB0t/Morpion" bg="linear-gradient(to right, rgb(0, 117, 55) 0%, rgb(184, 172, 2) 100%)" mdxType="ProjectCard">
Projet Java en ligne de commande pour deux joueurs, aucune bibliothèque utilisée. Implémentation de MVC ainsi que d'observateurs.
    </ProjectCard>
    <ProjectCard title="2048" link="https://github.com/TotallyNotAB0t/2048_Game_Website" bg="linear-gradient(to right, rgb(82, 36, 112) 0%, rgb(182, 15, 88) 100%)" mdxType="ProjectCard">
2048 en Python, ainsi qu'un site expliquant son fonctionnement et sa création (HTML + CSS). Utilisation de TKinter.
    </ProjectCard>
    <ProjectCard title="échecs" link="https://github.com/TotallyNotAB0t/Chess" bg="linear-gradient(to right, rgb(81, 0, 124) 0%, rgb(0, 204, 194) 100%)" mdxType="ProjectCard">
Jeu d'échecs Java en ligne de commande. Pour deux joueurs, aucune bibliothèque utilisée.
    </ProjectCard>
    <ProjectCard title="Country Hunter" link="https://github.com/TotallyNotAB0t/CountryHunter" bg="linear-gradient(to right, rgb(170, 16, 72) 0%, rgb(168, 103, 3) 100%)" mdxType="ProjectCard">
Creation d'un jeu vidéo en Python utilisant la bilibothèque TKinter. Projet de Terminale en ISN, par groupe de 3.
    </ProjectCard>
    <ProjectCard title="Escape Game" link="https://github.com/TotallyNotAB0t/Escape_Game_Website" bg="linear-gradient(to right, rgb(3, 181, 252) 0%, rgb(3, 103, 252) 100%)" mdxType="ProjectCard">
Site en HTML et CSS présentant une salle d'Escape Game ainsi que sa page de réservation.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      